import { createContext } from 'react';

import type { RouteConfig } from '@shared/types/common.types';

import { getLayoutViewValue } from './getLayoutViewValue';

interface LayoutViewContextValue {
  capabilityVersion: string;
  isCommonView: boolean;
  isMobileView: boolean;
  isPortalView: boolean;
  isSharedServiceView: boolean;
  isStandardView: boolean;
  sourceApp: string;
  sourceAppView: string;
}
const LayoutViewContext = createContext<LayoutViewContextValue | null>(null);

let getLayoutViewBridge: (() => LayoutViewContextValue) | undefined;
let bridgeRoutes: RouteConfig[] = [];

const LayoutViewBridge = {
  /**
   * Always resolves to a usable layout view.
   *
   * `LayoutViewContextProvider` lives inside a route element under `RouterProvider`, so anything
   * running before the router renders — OIDC's `authenticatingErrorComponent`, the root route
   * `ErrorBoundary`, the axios interceptor — would otherwise read an unset bridge and get
   * `undefined`. In that state, recompute the same value from `window.location` instead.
   */
  getLayoutViewBridge(): LayoutViewContextValue {
    return getLayoutViewBridge?.() ?? getLayoutViewValue({ location: window.location.pathname, ROUTES: bridgeRoutes });
  },
  setGetLayoutViewBridge(fn: () => LayoutViewContextValue) {
    getLayoutViewBridge = fn;
  },
  /** Seeded once from `App.tsx`'s boot wiring, so the pre-router fallback can match routes. */
  setRoutes(ROUTES: RouteConfig[]) {
    bridgeRoutes = ROUTES;
  },
};

export type { LayoutViewContextValue };
export { LayoutViewBridge, LayoutViewContext };
